module.exports = __webpack_public_path__ + "pipeHead.png?d514d72ec6989e1a4ae94664809cbe03";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pipeHead.png
// module id = 6
// module chunks = 0